<template>
	<!-- 头部查询  start -->
	<div class="msi-form">
	<el-form :model="query" label-width="100px">
		<el-row>
			<el-col :span="6">
			  <el-form-item label="项目号:">
			    <el-input v-model="query.ProjectCode" clearable placeholder="请输入项目号" />
			  </el-form-item>
			</el-col>
			<el-col :span="6">
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="onQuery">查询</el-button>
			    <el-button icon="el-icon-refresh-right" @click="onReset">重置</el-button>
					<!-- <span @click="openSearch" class="openSearch_Style">
						{{ hidden ? "收起" : "展开" }}
						<i :class="hidden ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" />
					</span> -->
				</el-form-item>
			</el-col>		
		</el-row>
	</el-form>

	</div>
	<!-- 头部查询  end -->
	
	<div class="msi-content">
		<!-- 表格上面部分  start -->
		<div class="header">
			<div>
				<!-- <el-button type="primary" icon="el-icon-plus" @click="onOpenEdit('','add')">新增</el-button> -->
			</div>
			<div>
				<table-columns-select v-model:list="columns" />
			</div>
		</div>
		<!-- 表格上面部分  end -->
		<!-- @row-click="creatingShipDetail" -->
		<el-card>
			<el-table :data="list" border row-key="id" ref="singleTableRef" highlight-current-row :height="tableHeight">
			<el-table-column label="序号" align="center" width="60">
				<template #default="scope">
					{{(queried.PageNo-1)*queried.PageSize+(scope.$index+1)}}
				</template>
			</el-table-column>
			<el-table-column label="项目编号" align="center" >
			<template #default="scope">
				<span style="color: sandybrown;cursor: pointer;" @click="detailsOpen(scope.row.projectCode)">{{ scope.row.projectCode }}</span>
			</template>
			</el-table-column>
			<template v-for="(colItem,colIndex) in columns" :key="'table-col-'+colIndex">
				<el-table-column
					v-if="colItem.show"
						:fixed="colItem.fixed?colItem.fixed:undefined"
						:width="colItem.width?colItem.width:undefined"
						:align="colItem.align?colItem.align:'center'"
						:prop="colItem.field?colItem.field:undefined"
						:label="colItem.label"
					>					
				</el-table-column>
			</template>			
			<!-- <el-table-column label="操作" width="220" align="center" >
			  <template #default="scope">			   
				<el-button type="primary" size="small" icon="el-icon-plus"
                @click="buildOrder(scope.row)">建单</el-button>
			  </template>
			</el-table-column> -->
		</el-table>
		<div style="display:flex;justify-content:flex-end;padding-top: 8px;">
			<el-pagination :background="true" :total="total" v-model:current-page="queried.PageNo" v-model:page-size="queried.PageSize"
				layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" @current-change="handleCurrentChange" />
		</div>
		</el-card>
		 <!-- 详情 -->
         <!-- <info-block :info="info" v-model:visible="infoShow"  v-show="infoShow"  /> -->
		 <detailsInfo ref="detailInfo"  @reloadTable="reloadTable" />	
	</div>
	
	<!-- <detail-drawer 
		v-model:visible="detailVisible" 
		:detail-id="detailId" 
		:order-no="detailOrderNo" 
		:order-type="detailOrderType" 
		:type="detailType" 
		@load-data="getOrderDetailInfo" 
		@callback="onDeatilActionCallback"
	/> -->
	 <!-- 新建单据 -->
	<new-build
		v-model:visible="infoShow"
		:info="info" 
		@load-init-data="getOrderDetailInfo" 
		@callback="onDeatilActionCallback"
	/>
	
</template>


<script setup>
import {onMounted, reactive, ref, nextTick, getCurrentInstance } from 'vue'
import { purchase } from '@/service/main/invoices/buildGoods'
import { getPoPageList } from '@/service/main/invoices/localtionOrder'
import { getDicListData } from '@/service/main/warehouse/dicWare'
import TableColumnsSelect from '@/components/TableColumnsSelect.vue'
// const detailsInfo = defineAsyncComponent(() => import("./detailsInfo.vue"));
//import DetailDrawer from './module/DetailDrawer.vue'
import NewBuild from './module/newBuild.vue'
import detailsInfo from './module/detailsInfo.vue'
// import infoBlock from './module/infoBlock.vue'
import { ElMessage, ElMessageBox, ElLoading,ElTable} from 'element-plus';
const defaultQuery = {
	dateRange:[],
	PurchaseNo: "",
	ProjectCode: "",
	SupplierInfoName: "",
}
const pagination = {
	PageNo: 1,
	PageSize: 20
}
// 顶部占位过多 展开/收起
const hidden = ref(false);
const openSearch = () => {
    hidden.value = !hidden.value;
};
const instance = getCurrentInstance()
	
const query = reactive({...defaultQuery})
const queried = reactive({...pagination})
const selectOptions = reactive({
	status:[]
})
// 步骤条内容
let tableHeight = ref(0)
// onMounted(() => {
    tableHeight.value = window.innerHeight - 240;
// })
const list = ref([])
const total = ref(0)
const columns = ref([
	{
		label:'采购数量',
		field:'purchaseNumber',
		show:true
	},
	{
		label:'送货数量',
		field:'deliveryQuantity',
		show:true
	},
	{
		label:'收货数量',
		field:'collectQuantity',
		show:true
	},
	{
		label:'质检数量',
		field:'qualityNumber',
		show:true
	},
	{
		label:'入库数量',
		field:'warehousingQuantity',
		show:true
	},
	{
		label:'创建时间',
		field:'createdTime',
		show:true
	},
])

const detailVisible = ref(false)
const detailId = ref('')
const detailType = ref('')
const detailOrderNo = ref('')
const detailOrderType = ref('')

const getStatusOptions = function(){
	getDicListData({CodeList:'issue_status'}).then((d)=>{
		selectOptions.status = d.data[0] || []
	}).catch((err)=>{
		console.log(err)
	})
}

const onQuery = function(){
	newList()
}

const onReset = function(){
	reset()
}

const newList = function(){
	for (let name in query) {
		if (name==='dateRange') {
			if (query[name]===null || query[name].length===0) {
				queried.SearchBeginTime = ''
				queried.SearchEndTime = ''
			} else {
				queried.SearchBeginTime = query[name][0] + ' 00:00:00'
				queried.SearchEndTime = query[name][1] + ' 23:59:59'
			}
		} else {
			queried[name] = query[name]
		}
	}
	for (let name in pagination) {
		queried[name] = pagination[name]
	}
	getList()
}

const singleTableRef = ref()
const getList = function(){
	getPoPageList(queried).then((res) => {
		list.value = res.data.rows
		total.value = res.data.totalRows
		// creatingShipDetail(list.value[0],null)
		// singleTableRef.value.setCurrentRow(list.value[0]);
	}).catch((err)=>{
		console.log(err)
	})
}
const reloadTable = () =>{
	newList()
}
const reset = function(){
	for (let name in defaultQuery) {
		query[name] = defaultQuery[name]
	}
	newList()
}

const handleSizeChange = function(pageSize){
	queried.PageNo = 1
	queried.PageSize = pageSize
	getList()
}

const handleCurrentChange = function(page){
	queried.PageNo = page
	getList()
}

const onOpenDetail = function(obj,type) {
	detailId.value = obj.id
	detailType.value = type
	detailOrderNo.value = obj.orderNo
	detailOrderType.value = obj.orderType
	detailVisible.value = true
}
const info = ref({});
const infoShow = ref(false);
const buildOrder = function(row) {
	info.value = row
	infoShow.value = true
}

const onDeatilActionCallback = function(){
	getList()
}

const getOrderDetailInfo = function(params,callback) {
	purchase(params).then((res) => {
	  callback && callback(true,res)
	}).catch(()=>{
		callback && callback(false)
	})
}
 //详情
const detailsReset = () => {
    info.value.detailId = ""
    infoShow.value = false  
}

const creatingShipDetail = async function(params,column) {
	await detailsReset()
	if(column && column.label == '操作') return
	//console.log('params',params)
    info.value.detailId = params.id
	infoShow.value = true
}
onMounted(()=>{
	getStatusOptions()
	reset()
})
//采购单详情
const detailInfo = ref()
const detailsOpen = (projectCode) =>{
  detailInfo.value.openDialog(projectCode)
}

</script>

<style lang="less" scoped>

</style>